import React from 'react';

interface LinedMoldIconProps extends React.SVGAttributes<SVGElement> {
  size?: number | string;
  color?: string;
  strokeWidth?: number;
  showHolders?: boolean;
  showEyes?: boolean;
  showMouth?: boolean;
}

const LinedMoldIcon: React.FC<LinedMoldIconProps> = ({
  size = 24,
  color = '#9CA3AF',
  strokeWidth = 160,
  showHolders = false,
  showEyes = false,
  showMouth = false,
  ...props
}) => {
  const adjustedStroke = strokeWidth * 2;
  const sideFill = color;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      strokeWidth={adjustedStroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Mold holders */}
      {showHolders && (
        <>
          {/* Left holder: connector line + bigger donut circle */}
          <rect
            x="368"
            y="152"
            width="32"
            height="48"
            rx="10"
            fill="#D1D5DB"
            stroke={color}
            strokeWidth={adjustedStroke}
          />
          <circle
            cx="384"
            cy="128"
            r="48" // bigger outer radius
            fill="#D1D5DB"
            stroke={color}
            strokeWidth={adjustedStroke}
          />
          <circle
            cx="384"
            cy="128"
            r="18" // bigger inner radius
            fill="white"
            stroke={color}
            strokeWidth={adjustedStroke}
          />
          {/* Right holder: connector line + bigger donut circle */}
          <rect
            x="624"
            y="152"
            width="32"
            height="48"
            rx="10"
            fill="#D1D5DB"
            stroke={color}
            strokeWidth={adjustedStroke}
          />
          <circle
            cx="640"
            cy="128"
            r="48"
            fill="#D1D5DB"
            stroke={color}
            strokeWidth={adjustedStroke}
          />
          <circle
            cx="640"
            cy="128"
            r="18"
            fill="white"
            stroke={color}
            strokeWidth={adjustedStroke}
          />
        </>
      )}

      {/* Mold base */}
      <rect
        x="128"
        y="192"
        width="768"
        height="640"
        rx="64"
        fill="#F3F4F6"
        stroke={color}
        strokeWidth={adjustedStroke}
      />

      {/* Feet */}
      <rect x="192" y="832" width="128" height="48" rx="12" stroke={color} strokeWidth={adjustedStroke} fill="#F3F4F6" />
      <rect x="704" y="832" width="128" height="48" rx="12" stroke={color} strokeWidth={adjustedStroke} fill="#F3F4F6" />

      {/* Eyes */}
      {showEyes && (
        <>
          <circle cx="400" cy="420" r="24" fill="#6B7280" />
          <circle cx="624" cy="420" r="24" fill="#6B7280" />
        </>
      )}

      {/* Smile */}
      {showMouth && (
        <path
          d="M432 500c48 50 102 50 150 0" // more curve
          stroke="#6B7280"
          strokeWidth={strokeWidth * 10}
          strokeLinecap="round"
        />
      )}

      {/* Left-side vertical oval slots */}
      <rect x="140" y="340" width="12" height="32" rx="6" fill={sideFill} />
      <rect x="140" y="400" width="12" height="32" rx="6" fill={sideFill} />
      <rect x="140" y="460" width="12" height="32" rx="6" fill={sideFill} />
      <rect x="140" y="520" width="12" height="32" rx="6" fill={sideFill} />
      <rect x="140" y="580" width="12" height="32" rx="6" fill={sideFill} />

      {/* Right-side vertical oval slots */}
      <rect x="872" y="340" width="12" height="32" rx="6" fill={sideFill} />
      <rect x="872" y="400" width="12" height="32" rx="6" fill={sideFill} />
      <rect x="872" y="460" width="12" height="32" rx="6" fill={sideFill} />
      <rect x="872" y="520" width="12" height="32" rx="6" fill={sideFill} />
      <rect x="872" y="580" width="12" height="32" rx="6" fill={sideFill} />
    </svg>
  );
};

export default LinedMoldIcon;
